var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('qrcode-vue',{attrs:{"value":_vm.textToQR,"size":_vm.options.size,"level":_vm.options.level}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }